import React from 'react';

interface PipetteProps {
  volume?: number;        // mL, e.g., 10, 25
  fillLevel?: number;     // 0-100 percent
  fillColor?: string;     // Color of liquid
  label?: string;         // Label text
  active?: boolean;       // Whether pipette is being used
}

export default function Pipette({
  volume = 10,
  fillLevel = 0,
  fillColor = '#E6F3FF',
  label,
  active = false,
}: PipetteProps) {
  // Calculate liquid height based on fill level
  const liquidHeight = (fillLevel / 100) * 100; // max 100px for liquid section

  return (
    <svg viewBox="0 0 30 160" width={30} height={160}>
      {/* Bulb at top */}
      <ellipse
        cx="15"
        cy="12"
        rx="8"
        ry="10"
        fill={active ? '#F0F0F0' : '#E8E8E8'}
        stroke="#999"
        strokeWidth="1"
      />

      {/* Bulb indicator line */}
      <line x1="7" y1="12" x2="23" y2="12" stroke="#BBB" strokeWidth="0.5" />

      {/* Upper narrow section */}
      <rect
        x="12"
        y="22"
        width="6"
        height="15"
        fill="#F5F5F5"
        stroke="#999"
        strokeWidth="0.5"
      />

      {/* Main body - graduated section */}
      <rect
        x="10"
        y="37"
        width="10"
        height="100"
        fill="#F5F5F5"
        stroke="#999"
        strokeWidth="0.5"
        rx="1"
      />

      {/* Liquid in pipette */}
      {fillLevel > 0 && (
        <rect
          x="10.5"
          y={37 + (100 - liquidHeight)}
          width="9"
          height={liquidHeight}
          fill={fillColor}
          opacity="0.8"
        />
      )}

      {/* Graduation marks */}
      {[0, 20, 40, 60, 80, 100].map((pos, i) => (
        <React.Fragment key={i}>
          <line
            x1="10"
            y1={37 + pos}
            x2={i % 2 === 0 ? "14" : "12"}
            y2={37 + pos}
            stroke="#0066CC"
            strokeWidth="0.5"
          />
          {i % 2 === 0 && (
            <text
              x="24"
              y={37 + pos + 2}
              fontSize="5"
              fill="#666"
            >
              {Math.round((100 - pos) / 100 * volume)}
            </text>
          )}
        </React.Fragment>
      ))}

      {/* Lower tip */}
      <polygon
        points="13,137 17,137 15.5,155 14.5,155"
        fill="#F5F5F5"
        stroke="#999"
        strokeWidth="0.5"
      />

      {/* Liquid in tip */}
      {fillLevel > 0 && (
        <polygon
          points="13.5,137 16.5,137 15.5,153 14.5,153"
          fill={fillColor}
          opacity="0.8"
        />
      )}

      {/* Volume label */}
      {label && (
        <text
          x="15"
          y="160"
          fontSize="6"
          fill="#666"
          textAnchor="middle"
        >
          {label}
        </text>
      )}
    </svg>
  );
}
